import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchAgencyPublisherGenericProductNumbers } from "../api/publisherService";
export var usePublisherGenericProductNumbersData = function (publisherId) {
    var _a;
    var ky = useOkapiKy();
    var _b = useQuery(["publisher-generic-product-numbers", publisherId], function () { return fetchAgencyPublisherGenericProductNumbers(ky, publisherId); }, {
        enabled: !!publisherId,
    }), data = _b.data, isLoading = _b.isLoading, isError = _b.isError, refetch = _b.refetch;
    var genericProductNumbersData = (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [];
    return {
        genericProductNumbersData: genericProductNumbersData,
        isLoading: isLoading,
        isError: isError,
        refetch: refetch,
    };
};
